import axios from 'axios';

export default {
  getAllMenus: function (id:any) {
    return new Promise((resolve, reject) => {
      axios.get('cms_menu_custom_settings/'+id)
        .then(response => {
          resolve(response.data);
        })
        .catch((error) => {
          console.log('error ' + error);
          reject(error);
        });
    });
  },
  getAllMenuForDropdown: function () {
    return new Promise((resolve, reject) => {
      axios.get('/all-cms-menu-for-dropdown')
        .then(response => {
          resolve(response.data);
        })
        .catch((error) => {
          console.log('error ' + error);
          reject(error);
        });
    });
  },
  store: function (payload: any) {
    return axios.post('cms_menu_settings', payload)
      .then(response => {
        return response.data;
      }).catch(error => {
        throw(error.response);
      });
  },
  update(id: any, payload: any) {
    return axios.put('cms_menu_settings/' + id, payload)
      .then(response => {
        return response.data;
      }).catch(error => {
        throw(error.response);
        return error;
      });
  },
  destroy(id: any) {
    return axios.delete('cms_menu_settings/' + id)
      .then(response => {
        return response.data;
      }).catch(error => {
        throw(error.response);
      });
  },
  getMenuDetail: function (id: any) {
    return new Promise((resolve, reject) => {
      axios.get('/cms_menu_settings/' + id)
        .then(response => {
          resolve(response.data);
        })
        .catch((error) => {
          console.log('error ' + error);
          reject(error);
        });
    });
  },
  saveMenuOrder: function (payload: any) {
    return new Promise((resolve, reject) => {
      axios.put('update-cms-menu-order', payload)
        .then(response => {
          resolve(response.data);
        }).catch(error => {
        reject(error);
      });
    });
  }
}
